var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.4997C10.725 16.4997 10.4896 16.4018 10.2938 16.2059C10.0979 16.0101 10 15.7747 10 15.4997V10.4122C10 10.2788 10.0271 10.1518 10.0812 10.0309C10.1354 9.91009 10.2083 9.80384 10.3 9.71217L13.0125 7.01217C13.1375 6.8955 13.2854 6.82467 13.4563 6.79967C13.6271 6.77467 13.7917 6.80384 13.95 6.88717C14.1083 6.9705 14.2229 7.08717 14.2938 7.23717C14.3646 7.38717 14.3792 7.54134 14.3375 7.69967L13.775 9.99967H16.5C16.7667 9.99967 17 10.0997 17.2 10.2997C17.4 10.4997 17.5 10.733 17.5 10.9997V11.9997C17.5 12.058 17.4938 12.1205 17.4812 12.1872C17.4688 12.2538 17.45 12.3163 17.425 12.3747L15.925 15.8997C15.85 16.0663 15.725 16.208 15.55 16.3247C15.375 16.4413 15.1917 16.4997 15 16.4997H11ZM8 16.4997C7.725 16.4997 7.48958 16.4018 7.29375 16.2059C7.09792 16.0101 7 15.7747 7 15.4997V10.9997C7 10.7247 7.09792 10.4893 7.29375 10.2934C7.48958 10.0976 7.725 9.99967 8 9.99967C8.275 9.99967 8.51042 10.0976 8.70625 10.2934C8.90208 10.4893 9 10.7247 9 10.9997V15.4997C9 15.7747 8.90208 16.0101 8.70625 16.2059C8.51042 16.4018 8.275 16.4997 8 16.4997Z",
    fill: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#F3E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpWhite);
export default __webpack_public_path__ + "static/media/thumb_up_white.7332a314317ac7ee44271ba7b4a0084a.svg";
export { ForwardRef as ReactComponent };